module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/repertorio_pic_libre.168a56ff.png";